import WIDGETS from './widgets';

export default {
	name: 'activity_summary',
	spacing: 0,
	widgets: [{ content: WIDGETS.ACTIVITY_SUMMARY, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
